<section id="main" class="bg-light">
     <div class="container">
          <div class="row">
               <div class="col-12">
               <div class="row">
                    <div class="col-auto">
                         <h1 class="page-title" [innerHtml]="'ackAuditHeader' | translator: 'base'">Audit Notification Acknowledgment</h1>
                    </div>
                    <div class="d-flex align-items-end col-auto mb-3 ms-lg-auto">
                         <button type="button" id="ackAuditPrintBtn" 
                              onclick="window.print()" class="btn btn-primary"
                              [title]="'ackAuditPrintBtn' | translator: 'base'"
                              [innerHtml]="'ackAuditPrintBtn' | translator: 'base'">Print</button>
                    </div>
               </div>
               <fieldset class="" [formGroup]="agreeInitials">                       
                    <legend class="mb-3">
                         <span [innerHtml]="'ackAuditCheckBoxText' | translator: 'base'">
                              I acknowledge that my company has been selected for a mandatory Pre-Employment Screening Program 
                              applicant disclosure and authorization form audit and that my company must provide evidence of 
                              the requested disclosure and authorization forms by the time specified in the initial notification 
                              email.
                         </span>
                    </legend>
                    <div class="">
                         <label
                              for="initials"
                              [title]="'ackAuditInitialsRequired' | translator: 'base'"
                              class="form-label"
                         >
                              <span [innerHtml]="'ackAuditInitialsRequired' | translator: 'base'">
                                   Initials (Required to proceed)
                              </span>
                              <span
                                   class="text-danger text-center ms-1"
                                   [title]="'Required' | translator: 'base'"
                              >*</span>
                         </label>
                         <input
                              [title]="'ackAuditInitialsRequired' | translator: 'base'"
                              class="form-control w-auto"
                              type="text"
                              id="initials"
                              name="initials"
                              size="3"
                              maxlength="3"
                              formControlName="initials"
                              #InitialsInput 
                         />
                         <div *ngIf="initials!.invalid && initials!.dirty" >
                              <span *ngIf="initials!.errors?.['required']"
                                   class="text-danger"
                                   [innerHtml]="'FieldRequired' | translator: 'base'"
                                   [title]="'FieldRequired' | translator: 'base'"
                              >This field is required.</span>
                              <span
                                   class="text-danger"
                                   [innerHtml]="'InitialsLength' | translator: 'base'"
                                   [title]="'InitialsLength' | translator: 'base'"
                                   *ngIf="initials!.hasError('minlength')"
                              >Please enter at least 2 characters.</span>
                              <span
                                   class="text-danger"
                                   [innerHtml]="'AlphaOnly' | translator: 'base'"
                                   [title]="'AlphaOnly' | translator: 'base'"
                                   *ngIf="initials!.errors?.['pattern']"
                              >Please use letters only.</span>
                         </div>
                    </div>
                    <div class="mt-3">
                         <button
                              to="/signup/16"
                              (click)="acknowledgeAudit()"
                              [disabled]="initials!.errors"
                              class="btn btn-primary btn-strong me-2 mb-2"
                              [title]="'ackAuditSave' | translator: 'base'"
                              name="ackAuditSave"
                              id="ackAuditSave"
                         >
                              <span
                                   [innerHtml]="'ackAuditSave' | translator: 'base'"
                              >Acknowledge Now</span>
                         </button>
                         <button
                              (click)="doNotAcknowledgeAudit()"
                              class="btn btn-outline-primary mb-2"
                              [title]="'ackAuditDoNotAck' | translator: 'base'"
                              name="doNotAckAudit"
                              id="doNotAckAudit"
                         >
                              <span
                                   [innerHtml]="'ackAuditDoNotAck' | translator: 'base'"
                              >Do Not Acknowledge</span>
                         </button>
                    </div>
               </fieldset>
               <div *ngIf="pageState === 'Saved'" class="mt-3">
                    <button 
                         class="btn btn-primary btn-strong"
                         id="btnContinue" name="btnContinue"
                         [title]="'Continue' | translator: 'base'"
                         (click)="toDashboard()"
                    >
                         <span class="" [innerHtml]="'Continue' | translator: 'base'">Continue</span>
                    </button>
               </div>
               </div>
          </div>
     </div>

     <ng-template #DoNotAcknowledgeModal let-modal>
          <div class="modal-header">
               <h3 
                    id="doNotAcknowledgeModalTitle"
                    class="modal-title" slot="header" 
                    [innerHtml]="'ackAuditDoNotAck' | translator: 'base'"
               >
                    Do Not Acknowledged
               </h3>
          </div>
          <div class="modal-body">
               <span [innerHtml]="'ackAuditDoNotAckText' | translator: 'base'">
                    By declining to acknowledge your audit participation, you are aware that penalties can be imposed by the United States Department of Transportation Federal Motor Carrier Safety Administration.
               </span>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary ms-2"
                    [title]="'OK' | translator: 'base'"
                    name="doNotAckOk" 
                    id="doNotAckOk"
                    (click)="toDashboard()">
               <span [title]="'OK' | translator: 'base'" [innerHtml]="'OK' | translator: 'base'">OK</span>
               </button>                        
               <button class="btn btn-outline-primary"
                    [title]="'Cancel' | translator: 'base'"
                    name="cancel" 
                    (click)="closeDoNotAcknowledgeAudit()">
               <span [title]="'Cancel' | translator: 'base'" [innerHtml]="'Cancel' | translator: 'base'">Cancel</span>
               </button>
          </div>
     </ng-template>

     <div
          class="overlay"
          *ngIf="saving"
     >
          <h1 class="heading" [innerHtml]="'SavingLoaderText' | translator: 'base'">Saving</h1>
          <img />
     </div>   
     <div
          class="overlay"
          *ngIf="validating"
     >
          <h1 class="heading" [innerHtml]="'validating' | translator: 'base'">Validating</h1>
          <img />
     </div>   
</section>

